import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAdminConfig,
  signUpUserService,
  fetchCmsDetails,
} from '../services/adminService';

const initialState = {
  // For admin configs
  configs: null,
  isError: false,
  isLoading: false,
  message: '',

  // For user sign-up
  signUpData: null,
  isSigningUp: false,
  signUpError: false,
  signUpMessage: '',

  cmsData: null,
  isCmsLoading: false,
  isCmsError: false,
  cmsError: null,
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    resetAdminState: (state) => initialState,
    resetSignUpMessage: (state) => {
      state.signUpMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminConfig.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAdminConfig.fulfilled, (state, action) => {
        state.isLoading = false;
        state.configs = action.payload;
      })
      .addCase(fetchAdminConfig.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.configs = null;
      })
      .addCase(signUpUserService.pending, (state) => {
        state.isSigningUp = true;
        state.signUpError = false;
        state.signUpMessage = '';
      })
      .addCase(signUpUserService.fulfilled, (state, action) => {
        state.isSigningUp = false;
        state.signUpData = action.payload;
        // You can customize the success message based on your API response
        state.signUpMessage = action.payload.message || 'Sign up successful!';
      })
      .addCase(signUpUserService.rejected, (state, action) => {
        state.isSigningUp = false;
        state.signUpError = true;
        state.signUpMessage = action.payload;
        state.signUpData = null;
      })
      .addCase(fetchCmsDetails.pending, (state) => {
        state.isCmsLoading = true;
        state.isCmsError = false;
        state.cmsError = null;
      })
      .addCase(fetchCmsDetails.fulfilled, (state, action) => {
        state.isCmsLoading = false;
        state.cmsData = action.payload;
        state.isCmsError = false;
        state.cmsError = null;
      })
      .addCase(fetchCmsDetails.rejected, (state, action) => {
        state.isCmsLoading = false;
        state.cmsData = null;
        state.isCmsError = true;
        state.cmsError = action.payload;
      });
  },
});

export const { resetAdminState, resetSignUpMessage } = adminSlice.actions;
export default adminSlice.reducer;